export default __webpack_public_path__ + "static/media/ISMO CLASS-2 EXAM PATTERN 2025.9d938807.pdf";